import {Constants} from '../../../../constants';
import {ChamberType} from '../../../types';
import {bleLog} from '../../../utils/Logger';
import {sleep} from '../../../utils/sleep';
import {LoraxProperties} from '../pikaparam';
import {Broadcast, FirmwareType, IPeakDevice} from './IPeakDevice';
import {PeakDeviceBase, PeakDeviceBaseOptions} from './PeakDeviceBase';

export class PeakLoraxDevice
  extends PeakDeviceBase<LoraxProperties>
  implements IPeakDevice
{
  constructor(o: Omit<PeakDeviceBaseOptions, 'firmwareType'>) {
    super({...o, firmwareType: FirmwareType.Lorax});
  }

  public async initialize() {
    await super.initialize();

    this.broadcast = await this.readBroadcast();
  }

  public async stopDabbing(): Promise<void> {
    await this.client.write<number>(
      'modeCmd',
      Constants.MODE_COMMAND.heatCycleAbort,
    );

    // if we send the IDLE command too fast, Lorax doesn't seem to like it
    // probably need to wait for Operating State to change before issuing IDLE
    // Question: Why do we go to IDLE also?
    await sleep(100);

    await this.client.write<number>('modeCmd', Constants.MODE_COMMAND.idle);
  }

  protected async readChamberType(): Promise<ChamberType> {
    const value = await this.client.read<number>('heaterType');

    if (Object.values(ChamberType).includes(value)) return value as ChamberType;

    return ChamberType.Classic;
  }

  private async readBroadcast(): Promise<Broadcast | undefined> {
    try {
      if (!this.tryGetApi('broadcastDataCounter')) return;

      return {
        counter: await this.client.read<number>('broadcastDataCounter'),
        key: await this.client.read<number[]>('broadcastDataKey'),
      };
    } catch (error) {
      // Broadcasting is not a core feature, so we can move forward if reading failed.
      // This might happen because of incorrect Peak identification.
      bleLog.error('Reading broadcast failed.', {error});
      return;
    }
  }
}
